// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"40":"560d2c2f","49":"44105b7e","881":"4ba549c8","978":"43386209"}[chunkId] + ".css";
};